<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
  yz-card
    yz-dialog-normal-header(title="Delete supplier" @close="handleCancel")
    .px-4.py-6
      .yz-medium-body-md.text-neutral-700.mb-4 Are you sure you want to delete this supplier details?
      .yz-regular-body-sm.text-neutral-700(style="white-space: pre-line;") {{ description }}
    yz-dialog-normal-actions
      yz-btn(size="lg" text label="Cancel" :disabled="loading" @click="handleCancel")
      yz-btn(size="lg" label="Confirm" color="danger" :loading="loading" @click="handleConfirm")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('input', false)
      this.$emit('canceled')
    },
    handleConfirm() {
      this.$emit('confirmed')
    }
  }
}
</script>
